import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import "../../../styles/payrole-system/payrole-table.css";
import {
  convertThenFormat1,
  formatDateTime,
  getMonthYear,
} from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import PayroleApprovalForm from "./PayroleApprovalForm";
import { renderActionButton } from "../PayroleMocks";
import PayrollDetailsModal from "../PayrollDetailsModal";
import PayroleTableMobile from "../mobile-responsive/PayroleTableMobile";
import IncentiveCalculationModal from "./IncentiveCalculationModal";
import PayrollEditForm from "./PayrollEditForm";
import {
  BinIcon1,
  EditIcon1,
  EmailIcon,
  EyeIcon,
  WalletIcon,
} from "../../../images/icons/icons";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const PayroleTable = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  isDraft,
}) => {
  const dispatch = useDispatch();
  const {
    employeePayrollData,
    employeePayrollLoading,
    employeePayrollError,
    draftPayrollData,
    draftPayrollLoading,
    draftPayrollError,
  } = useSelector((state) => state.payrole);

  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const iniDatas = {
    pagination: [],
    allData: [],
    draftPayrollData: [],
    draftPayrollPagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [selectedDraftIds, setSelectedDraftIds] = useState([]);

  const handleModalClick = (row, name) => {
    setModValues({
      isModOpen: true,
      modName: name,
      rowData: row,
    });
  };

  const handleModalClose = () => {
    setModValues(iniModValues);
    setSelectedDraftIds([]);
  };

  const handleSelectAllDraft = () => {
    if (selectedDraftIds.length === allDatas.draftPayrollData.length) {
      setSelectedDraftIds([]);
    } else {
      setSelectedDraftIds(allDatas.draftPayrollData.map((row) => row.uid));
    }
  };

  const handleSelectDraftRow = (uid) => {
    setSelectedDraftIds((prev) =>
      prev.includes(uid) ? prev.filter((id) => id !== uid) : [...prev, uid]
    );
  };

  const handleDeleteDraftPayroll = async (rowData) => {
    if (rowData?.uid) {
      const filter = {
        uid: rowData?.uid,
      };

      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/payrole/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete payroll for this ${
          rowData?.account_type?.replace(/_/g, " ") || "Satff"
        }: ${rowData?.name || ""} for the month of ${
          rowData?.date ? getMonthYear(rowData.date) : "-"
        }`
      );
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !employeePayrollLoading &&
      !employeePayrollError &&
      employeePayrollData?.status &&
      employeePayrollData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: employeePayrollData.data,
        pagination:
          employeePayrollData?.pagination?.length > 0
            ? employeePayrollData.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [employeePayrollLoading, employeePayrollError, employeePayrollData]);

  useEffect(() => {
    if (
      !draftPayrollLoading &&
      !draftPayrollError &&
      draftPayrollData?.status &&
      draftPayrollData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        draftPayrollData: draftPayrollData.data,
        draftPayrollPagination:
          draftPayrollData?.pagination?.length > 0
            ? draftPayrollData.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        draftPayrollData: [],
        draftPayrollPagination: [],
      }));
    }
  }, [draftPayrollLoading, draftPayrollError, draftPayrollData]);

  const columns = [
    {
      dataField: "date",
      text: "Payrole Month",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? getMonthYear(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "employee",
      text: "Employee",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-employee-info">
          <p className="pp-employee-payroll-employee-name">
            {row?.name || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "account_type",
      text: "Role",
      formatter: (_, row) => (
        <span className="tb-data">{row?.account_type?.replace(/_/g, " ")}</span>
      ),
    },
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "total_days",
      text: "Attendance",
      formatter: (_, row) => (
        <p className="pp-employee-payroll-attendance">
          <span className="pp-employee-payroll-present-text">
            {row?.total_present} Present
          </span>
          <br />
          <span className="pp-employee-payroll-absent-text">
            {row?.total_absent} Absent
          </span>
          {/* <br />
              <span className="pp-employee-payroll-absent-text">
                {row.total_leave} Leave
              </span>
              <br />
              <span className="pp-employee-payroll-absent-text">
                {row.total_half_day} Half Day
              </span>
              <br />
              <span className="pp-employee-payroll-absent-text">
                {row.total_weekoff} Week Off
              </span>
              <br />
              <span className="pp-employee-payroll-absent-text">
                {row.total_late} Late
              </span> */}
        </p>
      ),
    },
    {
      dataField: "monthly_salary",
      text: "Monthly Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.monthly_salary)}
          </span>
        );
      },
    },
    {
      dataField: "total_basic_salary",
      text: "Gross Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.total_basic_salary)}
          </span>
        );
      },
    },
    {
      dataField: "deduction",
      text: "Deductions",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-deduction-amount tb-data">
          -₹{convertThenFormat1(row?.deduction)}
        </span>
      ),
    },
    {
      dataField: "net_salary",
      text: "Net Salary",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.net_salary)}
        </span>
      ),
    },
    {
      dataField: "incentive",
      text: "incentive",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.incentive)}
        </span>
      ),
    },
    {
      dataField: "esi_amount",
      text: "ESI Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.esi_amount)}
        </span>
      ),
    },
    {
      dataField: "pf_amount",
      text: "PF/TDS Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.pf_amount)}
        </span>
      ),
    },
    {
      dataField: "user_approval",
      text: "Staff Review",
      formatter: (_, row) => (
        <span
          className={`pp-employee-payroll-badge ${
            row?.user_approval === "approved"
              ? "pp-green-badge"
              : row?.user_approval === "pending"
              ? "pp-yellow-badge"
              : "pp-red-badge"
          }`}
        >
          {row?.user_approval === "pending"
            ? "Pending Review"
            : row?.user_approval || "NA"}
        </span>
      ),
    },
    {
      dataField: "stack_holder_approval",
      text: "HR Approval",
      formatter: (_, row) => {
        const isResolved =
          row?.stack_holder_approval === "approved" ||
          row?.stack_holder_approval === "rejected";

        return (
          <span
            className={`pp-employee-payroll-badge ${
              row?.stack_holder_approval === "approved"
                ? "pp-green-badge"
                : row?.user_approval === "pending" ||
                  row?.stack_holder_approval === "pending"
                ? "pp-yellow-badge"
                : "pp-red-badge"
            }`}
          >
            {isResolved
              ? row?.stack_holder_approval
              : row?.user_approval === "pending"
              ? "Review Required"
              : row?.stack_holder_approval || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        const isStaff = row?.role === "receptionist" || row?.role === "trainer";

        return (
          <div className="pp-employee-payroll-actions">
            {renderActionButton(row, isStaff, handleModalClick)}
          </div>
        );
      },
    },
  ];

  const columnsDraft = [
    {
      dataField: "select",
      text: (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={
            allDatas.draftPayrollData.length > 0 &&
            selectedDraftIds.length === allDatas.draftPayrollData.length
          }
          onChange={handleSelectAllDraft}
          aria-label="Select all draft payrolls"
        />
      ),
      formatter: (_, row) => (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={selectedDraftIds.includes(row?.uid)}
          onChange={() => handleSelectDraftRow(row?.uid)}
          aria-label={`Select ${row?.name}`}
        />
      ),
    },
    {
      dataField: "date",
      text: "Payrole Month",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? getMonthYear(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "employee",
      text: "Employee",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-employee-info">
          <p className="pp-employee-payroll-employee-name">
            {row?.name || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "account_type",
      text: "Role",
      formatter: (_, row) => (
        <span className="tb-data">{row?.account_type?.replace(/_/g, " ")}</span>
      ),
    },
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "total_days",
      text: "Attendance",
      formatter: (_, row) => (
        <p className="pp-employee-payroll-attendance">
          <span className="pp-employee-payroll-present-text">
            {row?.total_present} Present
          </span>
          <br />
          <span className="pp-employee-payroll-absent-text">
            {row?.total_absent} Absent
          </span>
        </p>
      ),
    },
    {
      dataField: "monthly_salary",
      text: "Monthly Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.monthly_salary)}
          </span>
        );
      },
    },
    {
      dataField: "total_basic_salary",
      text: "Gross Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.total_basic_salary)}
          </span>
        );
      },
    },
    {
      dataField: "deduction",
      text: "Deductions",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-deduction-amount tb-data">
          -₹{convertThenFormat1(row?.deduction)}
        </span>
      ),
    },
    {
      dataField: "net_salary",
      text: "Net Salary",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.net_salary)}
        </span>
      ),
    },
    {
      dataField: "incentive",
      text: "incentive",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.incentive)}
        </span>
      ),
    },
    {
      dataField: "esi_amount",
      text: "ESI Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.esi_amount)}
        </span>
      ),
    },
    {
      dataField: "pf_amount",
      text: "PF/TDS Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.pf_amount)}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        const approvalRequestSent = row?.approval_request_send;
        const isTrainer = row?.account_type === "trainer";

        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="send-email"
              type="button"
              className={`pp-employee-payroll-action-button ${
                approvalRequestSent
                  ? "pp-transparent-badge text-green"
                  : "pp-blue-badge"
              }`}
              style={{ justifyContent: "flex-start" }}
              onClick={() => handleModalClick(row, "send_email")}
            >
              {approvalRequestSent ? "Email Sent" : "Send Email"}
            </button>

            <button
              key="view-payroll"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => handleModalClick(row, "view-payroll")}
              style={{ marginRight: "8px" }}
            >
              <EyeIcon />
              View
            </button>

            {isTrainer && (
              <button
                key="add-incentive"
                type="button"
                className="pp-employee-payroll-action-button pp-outlined-border"
                onClick={() => handleModalClick(row, "add-incentive")}
                style={{ marginRight: "8px" }}
              >
                <WalletIcon />
                Incentive
              </button>
            )}

            <button
              key="edit-payroll"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => handleModalClick(row, "edit-payroll")}
              style={{ marginRight: "8px" }}
            >
              <EditIcon1 />
              Edit
            </button>
            <button
              key="delete-payroll"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => handleDeleteDraftPayroll(row)}
              style={{ marginRight: "8px" }}
            >
              <BinIcon1 />
              delete
            </button>
          </div>
        );
      },
    },
  ];

  const columnsStaff = [
    {
      dataField: "date",
      text: "Payrole Month",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? getMonthYear(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "total_days",
      text: "Attendance",
      formatter: (_, row) => (
        <p className="pp-employee-payroll-attendance">
          <span className="pp-employee-payroll-present-text">
            {row?.total_present} Present
          </span>
          <br />
          <span className="pp-employee-payroll-absent-text">
            {row?.total_absent} Absent
          </span>
        </p>
      ),
    },
    {
      dataField: "monthly_salary",
      text: "Monthly Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.monthly_salary)}
          </span>
        );
      },
    },
    {
      dataField: "total_basic_salary",
      text: "Gross Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.total_basic_salary)}
          </span>
        );
      },
    },
    {
      dataField: "deduction",
      text: "Deductions",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-deduction-amount tb-data">
          -₹{convertThenFormat1(row?.deduction)}
        </span>
      ),
    },
    {
      dataField: "net_salary",
      text: "Net Salary",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.net_salary)}
        </span>
      ),
    },
    {
      dataField: "incentive",
      text: "incentive",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.incentive)}
        </span>
      ),
    },
    {
      dataField: "esi_amount",
      text: "ESI Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.esi_amount)}
        </span>
      ),
    },
    {
      dataField: "pf_amount",
      text: "PF/TDS Amount",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.pf_amount)}
        </span>
      ),
    },
    {
      dataField: "stack_holder_approval",
      text: "HR Approval",
      formatter: (_, row) => {
        const isResolved =
          row?.stack_holder_approval === "approved" ||
          row?.stack_holder_approval === "rejected";

        return (
          <span
            className={`pp-employee-payroll-badge ${
              row?.stack_holder_approval === "approved"
                ? "pp-green-badge"
                : row?.user_approval === "pending" ||
                  row?.stack_holder_approval === "pending"
                ? "pp-yellow-badge"
                : "pp-red-badge"
            }`}
          >
            {isResolved
              ? row?.stack_holder_approval
              : row?.user_approval === "pending"
              ? "Review Required"
              : row?.stack_holder_approval || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            {renderActionButton(row, isStaff, handleModalClick)}
          </div>
        );
      },
    },
  ];

  return (
    <>
      {modValues.isModOpen &&
        (modValues.modName === "staff" ||
          modValues.modName === "stakeholder" ||
          modValues.modName === "send_email" ||
          modValues.modName === "bulk_send_email") && (
          <PayroleApprovalForm
            userInfoData={userInfoData}
            payrollData={modValues.rowData}
            approvalType={modValues.modName}
            selectedDraftIds={selectedDraftIds}
            allDatas={allDatas}
            onClose={handleModalClose}
            callFunction={callFunction}
          />
        )}

      {modValues.isModOpen && modValues.modName === "view-payroll" && (
        <PayrollDetailsModal
          userInfoData={userInfoData}
          onClose={handleModalClose}
          rowData={modValues.rowData}
        />
      )}

      {modValues.isModOpen && modValues.modName === "add-incentive" && (
        <IncentiveCalculationModal
          userInfoData={userInfoData}
          payrollData={modValues.rowData}
          onClose={handleModalClose}
          callFunction={callFunction}
        />
      )}

      {modValues.isModOpen && modValues.modName === "edit-payroll" && (
        <PayrollEditForm
          userInfoData={userInfoData}
          payrollData={modValues.rowData}
          onClose={handleModalClose}
          callFunction={callFunction}
        />
      )}

      {isDraft && selectedDraftIds.length > 0 && (
        <div className="pp-bulk-email-section">
          <div className="pp-bulk-email-info">
            <span className="pp-bulk-email-count">
              {selectedDraftIds.length} payroll(s) selected
            </span>
            <button
              type="button"
              className="pp-bulk-email-btn"
              onClick={() => handleModalClick({}, "bulk_send_email")}
            >
              <EmailIcon color="#fff" /> Send Bulk Email
            </button>
            <button
              type="button"
              className="pp-clear-selection-btn"
              onClick={() => setSelectedDraftIds([])}
            >
              Clear Selection
            </button>
          </div>
        </div>
      )}

      <div className="pp-employee-payroll-table-wrapper pp-no-border-table hideMobile mt30">
        {employeePayrollLoading ? (
          <Loader />
        ) : (
          <PaymentLinkTable
            tableData={isDraft ? allDatas.draftPayrollData : allDatas.allData}
            tableColumns={
              isDraft ? columnsDraft : isStaff ? columnsStaff : columns
            }
            tablePagination={
              isDraft ? allDatas.draftPayrollPagination : allDatas.pagination
            }
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {employeePayrollLoading ? (
          <Loader />
        ) : (
          <PayroleTableMobile
            tableData={isDraft ? allDatas.draftPayrollData : allDatas.allData}
            tablePagination={
              isDraft ? allDatas.draftPayrollPagination : allDatas.pagination
            }
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            handleModalClick={handleModalClick}
            isStaff={isStaff}
            isDraft={isDraft}
          />
        )}
      </div>
    </>
  );
};

export default PayroleTable;
